// Online booking window — the internal mirror of the public repo's
// supabase/functions/_shared/bookingWindow.ts, which is the real gate (the hold
// and availability edge functions read it). Change both files together.
//
// This copy is for DISPLAY only: the homepage availability strip's date range
// and the "opens on" hints in Enquiries and Incomplete Bookings. Nothing here
// decides whether a booking is accepted.

export const CUSTOMER_WINDOW_DAYS = 7; // today + 7
export const PARTNER_WINDOW_DAYS = 9;  // approved partners only: today + 9

// IST calendar date (Asia/Kolkata, UTC+5:30) as YYYY-MM-DD. Shifting the clock
// by +5:30 and reading the UTC components gives the IST wall-clock date — the
// same "today" the availability function uses for its window and same-day cut-off.
export function istTodayIso() {
  return new Date(Date.now() + 5.5 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

// `iso` plus `days` calendar days, as YYYY-MM-DD. Pure UTC arithmetic so a DST
// or local-timezone shift can never move the date.
export function addDaysIso(iso, days) {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}
